import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import BulkUpload from "../pages/ExamController/BulkUpload/BulkUpload";
import CertificateList from "../pages/ExamController/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/ExamController/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/ExamController/Certificate/ViewCertificate/ViewCertificate";

var ExamControllerRoutes = [
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ExamControllerRoutes;
